<template>
  <div class="-Topbar" :class="{ sea: $area === 'komoe-sea' }">
    <router-link class="tb-logo" :to="{ name: 'home' }" ga-data="101001">
      <svg-icon name="logo"></svg-icon>
    </router-link>
    <router-link
      class="menu-hd"
      :to="{ name: 'news' }"
      ga-data="101002"
      v-if="navFlags.is_show_news"
    >
      <!-- <router-link class="menu-hd" :to="{name: 'news'}" ga-data="101002"> -->
      <svg-icon name="news"></svg-icon>
      {{ $t("header.news") }}
    </router-link>
    <a
      class="menu-hd"
      href="javascript:;"
      ga-data="101003"
      v-if="navFlags.is_show_game"
    >
      <!-- <a class="menu-hd" href="javascript:;" ga-data="101003"> -->
      <svg-icon name="news"></svg-icon>
      {{ $t("header.games") }}
      <div v-if="gameList.length > 0" class="menu-bd game-list">
        <a
          v-for="(item, index) in gameList"
          target="_blank"
          :href="item.url"
          :key="index"
        >
          <img :src="item.game_icon" />
          {{ item.game_name }}
          <svg-icon name="arrow-right" className="icon-right-arrow"></svg-icon>
        </a>
      </div>
    </a>

    <!-- komoe繁中充值页需要新开窗口跳转到komoe老官网 -->
    <router-link
      class="menu-hd"
      :to="{ name: 'paygame' }"
      ga-data="101009"
      v-if="navFlags.is_show_invest"
      :target="$area === 'komoe-sea' ? '_self' : '_blank'"
    >
      <!-- <a href="//www.komoejoy.com/paygame/" class="menu-hd menu-hd-div" ga-data="101009" target="_blank" :style="[switchStatus == 1 ? '{display: table-cell}' : '{display: none}']"> -->
      <svg-icon name="pay"></svg-icon>
      {{ $t("header.pay") }}
    </router-link>
    <a
      class="menu-hd"
      href="javascript:;"
      ga-data="101004"
      v-if="navFlags.is_show_fans_group"
    >
      <!-- <a class="menu-hd" href="javascript:;" ga-data="101004"> -->
      <svg-icon name="fans"></svg-icon>
      {{ $t("header.fans") }}
      <div v-if="fansList.length > 0" class="menu-bd menu-wide">
        <a
          v-for="(item, index) in fansList"
          target="_blank"
          :href="item.url"
          :key="index"
        >
          {{ item.group_name }}
          <svg-icon name="arrow-right" className="icon-right-arrow"></svg-icon>
        </a>
      </div>
    </a>
    <router-link
      class="menu-hd"
      :to="{ name: 'servicePC' }"
      ga-data="101005"
      v-if="navFlags.is_show_cs"
    >
      <!-- <router-link class="menu-hd" :to="{name: 'servicePC'}" ga-data="101005"> -->
      <svg-icon name="service"></svg-icon>
      {{ $t("header.service") }}
    </router-link>
    <a class="menu-hd" v-if="$area === 'komoe-sea'" href="javascript:;">
        <svg-icon name="lang"></svg-icon>
        <!-- {{$t('header.lang')}} -->
        {{ langDes }}
        <div v-if="languages.length > 1" class="menu-bd menu-wide">
            <a v-for="(item, index) in languages" :key="index" href="javascript:;" @click="switchLang(item)">
                {{item.label}}
            </a>
        </div>
    </a>
    <!-- pc登录模块 -->
    <div ref="rightBar" class="right-bar" :class="{logined: userInfo.mid || userInfo.user_id || userInfo.nick_name || userInfo.nickName}">
      <a class="tb-login one-row" @click.prevent="goLogin" ga-data="101006" v-if="$area === 'komoe-sea'">
        <div class="user-face"></div>
        <div>
          <div class="login-sup">{{ $t("header.signupAndLogin") }}</div>
          <div class="login-title">{{ $t("header.komoeMember") }}</div>
        </div>
        <svg-icon name="arrow-right" className="icon-right-arrow"></svg-icon>
      </a>
      <a
        class="user-hd one-row"
        href="javascript:;"
        :class="{ open: showUserOpts }"
        @mouseenter="handleUserOpts(true)"
        @mouseleave="handleUserOpts(false)"
      >
        <div class="user-face"></div>
        <span class="user-name"
          >Hi,<br /><b>{{ userInfo.nickName || userInfo.nick_name }}</b></span
        >
        <svg-icon
          name="arrow_down_circle"
          class="icon-right-arrow"
          v-if="$area === 'komoe-sea'"
        ></svg-icon>
        <div class="user-bd">
          <router-link
            to="/account"
            class="account"
            ga-data="101007"
            v-if="userType === 'account'"
          >
            <svg-icon name="account"></svg-icon>
            {{ $t("header.accountSet") }}
          </router-link>
          <a @click="logout" href="javascript:;" ga-data="101008">
            <svg-icon name="logout"></svg-icon>
            {{ $t("header.logout") }}
          </a>
        </div>
      </a>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
// import '@assetImages/svgs/logo.svg';
import svgIcon from "@/component/SvgIcon";
import store from "@/store";

export default {
  name: "header-pc",
  data() {
    return {
      distribution_region: 5,
      isLogin: false,
      gameList: [],
      fansList: [],
      switchStatus: 0,
      navFlags: {
        is_show_cs: 0,
        is_show_fans_group: 0,
        is_show_game: 0,
        is_show_invest: 0,
        is_show_news: 0,
      },
      showUserOpts: false,
      optsTimer: null,
    };
  },
  components: {
    svgIcon,
  },
  computed: {
    ...mapGetters(["globalLang", "languages", "userInfo", "userType"]),
    langDes() {
      return this.languages.find(lang => lang.lang === this.globalLang).label
    }
  },
  methods: {
    ...mapActions({
      setLang: 'setGlobalLang'
    }),
    switchLang(lang) {
      if (lang.lang === this.globalLang) {
        return
      }
      this.setLang(lang.lang)
      window.location.reload()
    },
    handleUserOpts(tag) {
      if (this.$area !== "komoe-sea") {
        return;
      }
      clearTimeout(this.optsTimer);
      if (tag) {
        this.showUserOpts = true;
      } else {
        this.optsTimer = setTimeout(() => {
          this.showUserOpts = false;
        }, 500);
      }
    },
    goLogin() {
      if (this.$router.currentRoute.name === "login") {
        return false;
      } else {
        this.$router.push({
          path: "/login",
          query: {
            redirect: location.href,
          },
        });
      }
    },
    logout() {
      const logout =
        this.$area === "komoe-sea"
          ? this.$apis.common.logOut
          : this.$apis.header.userLogout;
      logout(this.$utils.token("joy_jct")).then(() => {
        store.dispatch('clearUserInfo')
        let routerObj;
        if (this.$area === "komoe-sea") {
          routerObj = {
            path: "/login",
            query: {
              redirect: location.href,
            },
          }
        } else {
           routerObj = {
            path: "/"
          }
        }
        this.$router.push(routerObj);
      });
    },
    getGameList() {
      this.$apis.header.getGameList().then((res) => {
        if (res.data.code == 0) {
          res.data.data.forEach((i) => {
            this.gameList.push(i);
          });
        }
      });
    },
    getFansList() {
      this.$apis.header.getFansList().then((res) => {
        if (res.data.code == 0) {
          res.data.data.forEach((i) => {
            this.fansList.push(i);
          });
        }
      });
    }
  },
  created() {
    store.dispatch("getUserInfo");

    if (this.$area === "komoe-sea") {
      store.dispatch("getUserType");
    }

    this.$apis.header
      .getNavList()
      .then((res) => {
        if (res.data.code == 0) {
          if (res.data.data.is_show_game) {
            this.getGameList();
          }
          if (res.data.data.is_show_fans_group) {
            this.getFansList();
          }
          this.navFlags = Object.assign({}, res.data.data);
        } else {
          // 接口请求失败时展示客服
          this.navFlags.is_show_cs = 1;
        }
      })
      .catch(() => {
        // 接口请求失败时展示客服
        this.navFlags.is_show_cs = 1;
      });
    if (this.$area === "komoe-sea") {
      this.$apis.paygame
        .getSwitchStatus(this.distribution_region)
        .then((res) => {
          if (res.data.code == 0) {
            this.switchStatus = res.data.data.main_switch_status;
          }
        });
    } else {
      this.$apis.header.paySwitch().then((res) => {
        if (res.data.code == 0) {
          this.switchStatus = res.data.data.main_switch_status;
        }
      });
    }
  },
};
</script>
<style lang="scss" scoped>
$color-green: #2da2d4;

%vc {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.arrow-down {
  width: 12px;
  height: 12px;
}

.-Topbar {
  &.sea {
    font-weight: 100;
    .user-hd {
      margin-right: 36px;
      padding: 4px 6px;
      height: 54px;
      border-radius: 27px;
      border: 2px solid #2da2d4;
      .user-name {
        min-width: 85px;
        b {
          display: block;
          max-width: 120px;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
      }
      .user-bd {
        top: 130%;
      }
    }
    .menu-hd {
      width: 180px;
      font-weight: bolder;
    }
    .login-title {
      letter-spacing: 0 !important;
    }
    .tb-login {
      margin-right: 36px;
    }
  }
  // 单行布局
  .one-row {
    white-space: nowrap;
    > * {
      display: inline-block;
      white-space: normal;
    }
  }
  // 常用 icon
  .icon-right-arrow {
    display: inline-block;
    vertical-align: middle;
    width: 12px;
    height: 12px;
  }
  display: table;
  width: 100%;
  height: 80px;
  font-size: 16px;
  position: relative;
  z-index: 10;
  box-shadow: 0 2px 4px rgba(black, 0.1);
  min-width: 1300px;
  a {
    text-decoration: none;
    color: #444;
    fill: #ccc;
    &:hover {
      color: #2da2d4;
      fill: #2da2d4;
    }
  }
  // 左边 logo
  .tb-logo {
    display: table-cell;
    width: 375px;
    text-align: center;
    vertical-align: middle;
    fill: #000;
    svg {
      width: 135px;
      height: 33px;
    }
    img {
      height: 14px;
    }
  }
  // 中间菜单
  .menu-hd-div {
    display: none;
    color: #444;
    fill: #ccc;
    cursor: pointer;
    &:hover {
      color: #2da2d4;
      fill: #2da2d4;
    }
  }
  .menu-hd {
    display: table-cell;
    width: 150px;
    text-align: center;
    vertical-align: middle;
    position: relative;
    &.router-link-active {
      border-bottom: 4px solid $color-green;
    }
    > svg {
      display: inline-block;
      vertical-align: middle;
      width: 20px;
      height: 20px;
      margin-top: -3px;
      margin-right: 8px;
    }
    &:after {
      content: "";
      position: absolute;
      width: 1px;
      height: 30px;
      background-color: #eee;
      top: 40px;
      transform: translateY(-50%);
      right: 0;
    }
    .menu-bd {
      position: absolute;
      z-index: 1;
      top: 80px;
      background-color: #fff;
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
      font-size: 14px;
      width: 300px;
      text-align: left;
      box-shadow: 0 2px 4px rgba(black, 0.3);
      &.menu-wide {
        width: 360px;
      }
      a {
        display: block;
        min-height: 60px;
        line-height: 30px;
        box-sizing: border-box;
        padding: 15px 30px 15px 20px;
        position: relative;
      }
      .icon-right-arrow {
        fill: $color-green;
        @extend %vc;
        right: 20px;
        border-radius: 50%;
      }
      a:hover .icon-right-arrow {
        box-shadow: 0 2px 4px rgba(#0a83ba, 0.5);
      }
    }
    .menu-bd {
      display: none;
    }
    .menu-bd.game-list {
      a {
        padding-left: 60px;
      }
      img {
        box-sizing: border-box;
        width: 30px;
        height: 30px;
        border: 1px solid rgba(#444, 0.2);
        border-radius: 8px;
        @extend %vc;
        left: 20px;
      }
    }
    &:hover {
      .menu-bd {
        display: block;
      }
    }
    .menu-lang {
      width: 180px;
    }
  }
  .right-bar {
    display: table-cell;
    vertical-align: middle;
    text-align: right;
  }
  .user-face {
    background-repeat: no-repeat;
    background-image: url("./imgs/noface.svg");
    background-size: contain;
    width: 42px;
    height: 42px;
    border-radius: 50%;
    box-sizing: border-box;
    border: 2px solid #14b0f6;
    display: inline-block;
    vertical-align: middle;
  }
  .tb-login {
    display: inline-block;
    height: 50px;
    text-align: left;
    background-color: #2da2d4;
    border-radius: 25px;
    box-sizing: border-box;
    padding: 4px;
    color: white;
    fill: white;
    margin-right: 10px;
    box-shadow: 0 4px 6px rgba(#0a83ba, 0.3);
    position: relative;
    &:hover {
      background-color: #0a83ba;
      color: white;
      fill: white;
    }
    > * {
      vertical-align: middle;
    }
    .user-face {
      margin-right: 10px;
    }
    .login-sup {
      font-size: 12px;
      text-align: center;
      line-height: 18px;
    }
    .login-title {
      font-weight: bold;
      letter-spacing: 4px;
      line-height: 24px;
      white-space: nowrap;
    }
    .icon-right-arrow {
      margin-left: 10px;
      margin-right: 6px;
    }
  }
  .user-hd {
    display: none;
    min-width: 180px;
    height: 80px;
    box-sizing: border-box;
    padding: 19px 0;
    position: relative;
    text-align: left;
    .user-face {
      margin-right: 10px;
    }
    .user-name {
      display: inline-block;
      vertical-align: middle;
      font-size: 12px;
      color: #666;
      margin-right: 10px;
      b {
        font-size: 16px;
      }
    }
    .user-bd {
      position: absolute;
      width: 100%;
      top: 100%;
      background-color: #fff;
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
      box-shadow: 0 2px 4px rgba(black, 0.3);
      a {
        display: block;
        font-size: 14px;
        line-height: 17px;
        padding: 10px;
        color: #666;
        &:hover {
          color: $color-green;
        }
        svg {
          display: inline-block;
          vertical-align: middle;
          width: 20px;
          height: 20px;
          margin-right: 10px;
        }
      }
    }
    .user-bd {
      display: none;
    }
    &:hover .user-bd {
      display: block;
    }
    &.open {
      .user-bd {
        display: block;
      }
    }
  }
  .right-bar {
    &.logined {
      .tb-login {
        display: none;
      }
      .user-hd {
        display: inline-block;
      }
    }
  }

  &.dark {
    color: #ccc;
    .tb-logo {
      fill: #fff;
      &:hover {
        fill: #fff;
      }
    }
    a {
      color: #ccc;
      fill: #ccc;
      &:hover {
        color: #2da2d4;
        fill: #2da2d4;
      }
    }
    .menu-hd-div {
      display: none;
      color: #ccc;
      &:hover {
        color: #2da2d4;
      }
    }
    .menu-hd:after {
      background-color: #3d3d3d;
    }
    .tb-login {
      color: #fff;
      fill: #fff;
      &:hover {
        color: #fff;
        fill: #fff;
      }
    }
  }
}
</style>
